import { convertCredits } from '@packages/shared/core/common/entities';
import { ExpertCategory, CategorizedExpertsSection } from '@packages/shared/core/experts/entities';
import { SECOND_IN_MS } from './time';

export const ICE_BREAKING_TIPS: Array<string> = [
  'Will my ex and I get back together?',
  'When will I start a new relationship?',
  'Can you see any unresolved feelings between my ex and me?',
  'How is my ex feeling about me?',
  'Is there anything unresolved with my ex?',
  'Does my ex think about me?',
  'Did my ex cheat on me?',
];

export const EXPERT_MESSAGES: Array<string> = [
  "Hello my dear, I think it's time to give you answers to the questions that concern you. What would you like to find out?",
  "Nice to meet you! I'm here to help you to find answers on things that bothered you. You can ask me everything you want",
  'Hello, dear! I\u2019m here to help you with your questions to the Universe. What is bothered you?',
];

export const MATCH_EXPERT_PERCENTAGES = [100, 99, 97, 89, 88, 86] as const;

export const EXPERTS_SECTIONS: Record<string, CategorizedExpertsSection> = {
  [ExpertCategory.LOVE_READINGS]: {
    isLight: true,
    title: 'BEST IN LOVE & RELATIONSHIP',
    description: 'advisors with the highest accuracy in providing insights about love and relationship matters',
  },
  [ExpertCategory.DESTINY_AND_LIFE_PATH]: {
    title: 'Best in Destiny & Life path',
    description: 'advisors exceptionally accurate in illuminating your destiny and life path',
  },
  [ExpertCategory.CAREER_AND_WORK]: {
    title: 'Best in Career & work ',
    description: 'advisors known for their precision in navigating career and work-related questions',
  },
  [ExpertCategory.FUTURE_TELLING]: {
    title: 'Best in Future telling',
    description: 'advisors revered for their accuracy in predicting future events and outcomes.',
  },
  [ExpertCategory.FAMILY_AND_FRIENDS]: {
    title: 'Best in Family & Friends topic',
    description: 'advisors acclaimed for their accuracy in family and friendship-related inquiries',
  },
  [ExpertCategory.SPIRIT_GUIDANCE]: {
    title: 'Best in Spirit guidance',
    description: 'spiritual guides recognized for their exactitude in providing spiritual advice and direction',
  },
  [ExpertCategory.MOST_ACCURATE]: {
    title: 'TOP 3 PSYCHICS FOR YOU',
    description: 'best 3 psychics with the highest matching scores according to your quiz answers',
  },
  [ExpertCategory.ALL]: {
    title: 'all advisors',
  },
};

export const DEFAULT_CHAT_PRICE = 3;
export const DEFAULT_CHAT_PRICE_IN_CREDITS = convertCredits(DEFAULT_CHAT_PRICE);
export const DEFAULT_OFFLINE_QUESTION_PRICE = 8;
export const DEFAULT_OFFLINE_QUESTION_PRICE_IN_CREDITS = convertCredits(DEFAULT_OFFLINE_QUESTION_PRICE);
export const DEFAULT_WELCOME_CREDITS_AMOUNT = 150;
export const DEFAULT_WEEKLY_CREDITS_AMOUNT = 150;
export const INITIAL_EXPERTS_AMOUNT = 28;
export const EXPERT_CARD_VISIBILITY_THRESHOLD = 0.6;
export const DEFAULT_FREE_MINUTES = 3;
export const EXPERIMENTAL_FREE_MINUTES = 5;
export const ACTIVATION_QUEST_TOTAL_SPEND_MINUTES = 5;
export const FREE_TRIAL_CREDITS_CURRENCY_EQUIVALENT = 14;
export const NOTIFICATION_AUTO_CLOSE_DELAY = 5 * SECOND_IN_MS;

export const SUPPORT_BOT_TAGS: Array<string> = ['Ask_Nebula'];

export const SUPPORT_PHONE_NUMBER = {
  alias: '+1 646-603-1815',
  original: '+16466031815',
} as const;

export const FUNNEL_BUILDER_SIMPLE_REGISTRATION_URL = '/funnels/simple_registration';

export const SCHEMA = {
  publisherName: 'Nebula',
  publisherType: 'Spiritual Platform',
} as const;
